import { type ThunkDispatch } from 'redux-thunk';
import { type AnyAction, applyMiddleware, createStore, compose } from 'redux';
import { useDispatch as useDispatchCore, useSelector as useSelectorCore, useStore as useStoreCore } from 'react-redux';
import { rootReducer } from '../reducers';
import { type StoreState } from '../types/StoreState';
import { middlewares } from './middlewares';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

export const configureStore = (initialState?: Partial<StoreState>) => {
  const store = createStore(rootReducer, initialState, composeEnhancers(applyMiddleware(...middlewares)));

  if (process.env.NODE_ENV === 'development' && (module as any).hot) {
    (module as any).hot.accept('../reducers', () => {
      store.replaceReducer(require('../reducers').rootReducer);
    });
  }

  return store;
};

// TODO: Fix dispatch type - https://redux-toolkit.js.org/usage/usage-with-typescript#getting-the-dispatch-type
// Wrong inferred type in createAsyncThunk - https://github.com/reduxjs/redux-toolkit/issues/710
export type AppDispatch = ThunkDispatch<StoreState, any, AnyAction>;
export const useDispatch = (): AppDispatch => useDispatchCore<AppDispatch>();
export const useStore = () => useStoreCore<StoreState>();
export const useSelector = <TSelected = unknown, TState = StoreState>(
  selector: (state: TState) => TSelected,
  equalityFn?: (left: TSelected, right: TSelected) => boolean,
): TSelected => {
  return useSelectorCore<TState, TSelected>(selector, equalityFn);
};
